import React from 'react';
import { BsPatchCheckFill } from 'react-icons/bs';
import './SkillCard.css';

const SkillCard = ({ title, data }) => {
  const getLevelWidth = (level) => {
    const levels = { Advanced: 90, Experienced: 70, Intermediate: 50, Beginner: 30 };
    return levels[level] || 50; // Default to 50% if level not recognized
  };

  return (
    <div className="skill__card">
      <h3>{title}</h3>
      <div className="skill__content">
        {data.map((list, index) => (
          <article className="skill__details" key={index}>
            <BsPatchCheckFill className="skill__icon" />
            <div className="skill__info">
              <h4 className="skill__name">{list.skill}</h4>
              <div className="skill__progress-bar">
                <div
                  className="skill__progress"
                  style={{ width: `${getLevelWidth(list.level)}%` }}
                ></div>
              </div>
              <small className="skill__level">{list.level}</small>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default SkillCard;
